import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahClientInvoices } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

interface EstimateRequest {
  invoice_date: string;
}

interface EstimateClient {
  id: number;
  client_name: string;
  total_contribution_amount: number;
  reconciliations: string[];
}

interface EstimateResponse {
  overall_total: number;
  clients: EstimateClient[];
}

interface CreateResponse {
  invoices_count: number;
}

export const clientInvoicesApi = createApi({
  reducerPath: 'clientInvoicesApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahClientInvoices }),
  tagTypes: ['client-invoices', 'client-invoice-estimates'],
  endpoints: (builder) => ({
    getInvoices: builder.query<any[], Request | void>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'client-invoices', id: 'LIST' }],
      transformResponse: (payload) => unwrap<any[]>(payload),
    }),
    getInvoice: builder.query<any, Request & { id: string }>({
      query: ({ id, ...rest }) => ({ url: `/${id}`, method: 'GET', params: rest }),
      providesTags: (_result, _error, { id }) => [{ type: 'client-invoices', id }],
      transformResponse: (payload) => unwrap<any>(payload),
    }),
    estimate: builder.query<EstimateResponse, EstimateRequest>({
      query: (params) => ({ url: '/estimate', method: 'GET', params }),
      providesTags: [{ type: 'client-invoice-estimates', id: 'LIST' }],
      transformResponse: (payload) => unwrap<EstimateResponse>(payload),
    }),
    create: builder.mutation<CreateResponse, EstimateRequest & { due_date: string }>({
      query: (body) => ({ url: '', method: 'POST', body }),
      invalidatesTags: [
        { type: 'client-invoices', id: 'LIST' },
        { type: 'client-invoice-estimates', id: 'LIST' },
      ],
      transformResponse: (payload) => unwrap<CreateResponse>(payload),
    }),
  }),
});

export const { useGetInvoicesQuery, useGetInvoiceQuery, useEstimateQuery, useCreateMutation } = clientInvoicesApi;
